import { Component } from '@angular/core';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from "../../../../models/GenericCRUD/GenericTable";
import { GenericForm, GenericFormField } from "../../../../models/GenericCRUD/GenericForm";
import { Paginator } from "../../../../models/Paginator";
import { Office } from "../../../../models/Office";
import { GenericCRUD } from "../../../../models/GenericCRUD/GenericCRUD";
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-office-configuration',
  standalone: true,
  imports: [
    GenericCrudComponent,
    RouterLink
  ],
  templateUrl: './office-configuration.component.html',
  styleUrl: './office-configuration.component.css'
})
export class OfficeConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Teléfono', active: true, type: 'text', key: 'phone', sort: false },
    { name: 'Email', active: true, type: 'text', key: 'email', sort: false },
    { name: 'Dirección', active: true, type: 'text', key: 'full_address', sort: false },
    { name: 'Activa', active: true, type: 'boolean', key: 'active', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  classroomFormFields: GenericFormField[] = [
    { name: 'id', type: 'hidden', label: 'ID', validations: '', colspan: 1 },
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', colspan: 1, testValue: 'Centro 1' },
    { name: 'capacity', type: 'number', label: 'Capacidad', validations: 'required', colspan: 1, testValue: '10' },
  ];


  classroomForm: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.classroomFormFields,
    name: 'classroom',
    createButtonTitle: 'Nueva Clase',
    cols: 2,
    createApiSlug: '/config/office/store',
    originalUpdateApiSlug: '/config/office/update/{{id}}',
    formTitle: 'Crear Clase',
    formButtonTitle: 'Crear Clase',
    updateFormTitle: 'Editar Clase',
    updateFormButtonTitle: 'Editar Clase',
    width: '4xl',
  }

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', testValue: 'Centro 1' },
    { name: 'phone', type: 'text', label: 'Teléfono', validations: 'required', testValue: '660066006' },
    { name: 'email', type: 'text', label: 'Email', validations: 'required', testValue: 'test@test.com' },
    { name: 'address', type: 'text', label: 'Calle', colspan: 1, testValue: 'Calle Mayor' },
    { name: 'address_number', type: 'text', label: 'Número', colspan: 1, testValue: '1' },
    { name: 'city', type: 'text', label: 'Localidad', colspan: 1, testValue: 'Alicante' },
    { name: 'province', type: 'text', label: 'Provincia', colspan: 1, testValue: 'Alicante' },
    { name: 'postal_code', type: 'text', label: 'Código Postal', colspan: 1, testValue: '03001' },
    { name: 'observations', type: 'textarea', label: 'Observaciones', colspan: 2 },
    { name: 'opening_hours', type: 'text', label: 'Horario de apertura', colspan: 1 },
    { name: 'location', type: 'text', label: 'Localización (iframe)', colspan: 1 },
    { name: 'active', type: 'boolean-switch', label: 'Activa', colspan: 1 },
    { name: 'images', type: 'image', label: 'Imagenes', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
    { name: 'documents', type: 'document', label: 'Documentos', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
    { name: 'classrooms', type: 'repeater', label: 'Clases', colspan: 2, singleSelection: false, genericForm: this.classroomForm },
    { name: 'responsibles', type: 'select', label: 'Responsables', colspan: 1, singleSelection: false, url: '/user/responsibles' },
    { name: 'teachers', type: 'select', label: 'Profesores', colspan: 1, singleSelection: false, url: '/user/teachers' },
    { name: 'operators', type: 'select', label: 'Operadoras', colspan: 1, singleSelection: false, url: '/user/operators' },
    { name: 'companies', type: 'select', label: 'Sociedades', colspan: 1, singleSelection: false, url: '/config/company/listAll' },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', testValue: 'Centro 1' },
    { name: 'phone', type: 'text', label: 'Teléfono', validations: 'required', testValue: '660066006' },
    { name: 'email', type: 'text', label: 'Email', validations: 'required', testValue: 'test@test.com' },
    { name: 'address', type: 'text', label: 'Calle', colspan: 1 },
    { name: 'address_number', type: 'text', label: 'Número', colspan: 1 },
    { name: 'city', type: 'text', label: 'Localidad', colspan: 1 },
    { name: 'province', type: 'text', label: 'Provincia', colspan: 1 },
    { name: 'postal_code', type: 'text', label: 'Código Postal', colspan: 1 },
    { name: 'observations', type: 'textarea', label: 'Observaciones', colspan: 2 },
    { name: 'opening_hours', type: 'text', label: 'Horario de apertura', colspan: 1 },
    { name: 'location', type: 'text', label: 'Localización (iframe)', colspan: 1 },
    { name: 'active', type: 'boolean-switch', label: 'Activa', colspan: 1 },
    { name: 'images', type: 'image', label: 'Imagenes', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
    { name: 'documents', type: 'document', label: 'Documentos', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
    { name: 'classrooms', type: 'repeater', label: 'Clases', colspan: 2, singleSelection: false, genericForm: this.classroomForm },
    { name: 'responsibles', type: 'select', label: 'Responsables', colspan: 1, singleSelection: false, url: '/user/responsibles' },
    { name: 'teachers', type: 'select', label: 'Profesores', colspan: 1, singleSelection: false, url: '/user/teachers' },
    { name: 'operators', type: 'select', label: 'Operadoras', colspan: 1, singleSelection: false, url: '/user/operators' },
    { name: 'companies', type: 'select', label: 'Sociedades', colspan: 1, singleSelection: false, url: '/config/company/listAll' },
  ];


  officeWizardSteps = [
    {
      label: 'Datos básicos',
      fieldNames: ['name', 'phone', 'email', 'active'],
      cols: 2,
    },
    {
      label: 'Dirección y horarios',
      fieldNames: ['address', 'address_number', 'city', 'province', 'postal_code', 'opening_hours', 'location', 'observations'],
      cols: 2,
    },
    {
      label: 'Recursos y personal',
      fieldNames: ['responsibles', 'teachers', 'operators', 'companies', 'images', 'documents', 'classrooms'],
      cols: 2,
    },
  ];

  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'sucursal',
    createButtonTitle: 'Nueva Sucursal',
    cols: 2,
    steps: this.officeWizardSteps,
    createApiSlug: '/config/office/store',
    formTitle: 'Crear Sucursal',
    formButtonTitle: 'Crear Sucursal',
    originalUploadFilesUrl: '/config/office/update-files/',
    uploadFilesUrl: '',
    width: '4xl'
  }



  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'sucursal',
        createButtonTitle: '',
        cols: 2,
        steps: this.officeWizardSteps,
        originalUpdateApiSlug: '/config/office/update/{{id}}',
        createApiSlug: '',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl',
        originalUploadFilesUrl: '/config/office/update-files/{{id}}',
        uploadFilesUrl: ''
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿ Desea eliminar la sucursal ?',
      deleteRowOnResponse: true,
      actionSlug: '/config/office/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<Office>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/office/list',
    paginate: true,
    name: 'sucursal',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|phone|email', operator: 'like', placeholder: 'Nombre, Teléfono, Email' },
  ];

  genericCRUD: GenericCRUD<Paginator<Office>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: false
  }
}
